import {showMessageFromResponse} from 'shared/utils';

import {RisksDocumentsApi} from '../api';
import {IDeleteRiskDocumentsArgs, IPostRiskDocumentsArgs} from '../api/types';
import {IGetDataArgs} from '../model/types';

export const RisksDocumentsService = {
    get: async (args?: IGetDataArgs) => {
        try {
            return await RisksDocumentsApi.getData(args);
        } catch (error) {
            console.error(error);
            showMessageFromResponse({response: error.response, isError: true});

            throw new Error(error);
        }
    },

    getRuleByRiskId: async (id: number) => {
        try {
            return await RisksDocumentsApi.getRuleDataByRiskId(id);
        } catch (error) {
            console.error(error);
            showMessageFromResponse({response: error.response, isError: true});

            throw new Error(error);
        }
    },

    post: async (args: IPostRiskDocumentsArgs) => {
        try {
            const response = await RisksDocumentsApi.postData(args);
            showMessageFromResponse({response});
        } catch (error) {
            console.error(error);
            showMessageFromResponse({response: error.response, isError: true});

            throw new Error(error);
        }
    },

    delete: async (rowsIds: IDeleteRiskDocumentsArgs) => {
        try {
            const response = await RisksDocumentsApi.deleteData(rowsIds);
            showMessageFromResponse({response});
        } catch (error) {
            showMessageFromResponse({response: error.response, isError: true});

            throw new Error(error);
        }
    },
};
